import type { JournalEntry } from './types'

const KEY = 'linia_feed'
const MAX = 120

export function readJournal(): JournalEntry[] {
  try {
    return JSON.parse(localStorage.getItem(KEY) || '[]') as JournalEntry[]
  } catch {
    return []
  }
}

export function writeJournal(j: JournalEntry[]) {
  try {
    localStorage.setItem(KEY, JSON.stringify(j.slice(-MAX)))
  } catch {
    // квота localStorage исчерпана — режем ленту вдвое и пробуем ещё раз
    try {
      localStorage.setItem(KEY, JSON.stringify(j.slice(-Math.floor(MAX / 2))))
    } catch { /* сдаёмся молча: журнал не должен ронять сессию */ }
  }
}

export function upsertEntry(entry: JournalEntry) {
  const j = readJournal()
  const i = j.findIndex((e) => e.id === entry.id)
  if (i >= 0) j[i] = { ...j[i], ...entry }
  else j.push(entry)
  writeJournal(j)
}

export function setPost(id: number, post: string) {
  const j = readJournal()
  const i = j.findIndex((e) => e.id === id)
  if (i >= 0) {
    j[i].post = post
    writeJournal(j)
  }
}

/** Стрик считается по календарным дням записей, начиная с сегодня. */
export function streakDays(j: JournalEntry[] = readJournal()): number {
  if (!j.length) return 0
  const days = new Set(j.map((e) => new Date(e.d).toDateString()))
  let n = 0
  const t = new Date()
  while (days.has(t.toDateString())) {
    n++
    t.setDate(t.getDate() - 1)
  }
  return n
}
